import React from "react";
import { Link } from "gatsby";

const SeriesIndex = ({ seriesItems }) => {
  return (
    <div className="mt-4 mb-10 border border-grey-lightest shadow-md p-12 rounded">
      <h1 className="text-lg">Artículos en esta serie:</h1>
      <ol>
        {seriesItems.map((item, i) => (
          <li key={i}>
            <Link className="link" to={item.url}>
              {item.title}
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default SeriesIndex;
